import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom"; // use react-router-dom in frontend

interface GuestRouterProps {
  component: React.ComponentType<any>;
}

const GuestRouter: React.FC<GuestRouterProps> = ({ component: Component }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isLoggedIn } = useSelector((state: any) => state.auth);

  // handle redirect after profile is loaded
  useEffect(() => {
    const redirectTo = location.state?.redirectTo || "/";
    console.log("user :", user, redirectTo);

    if (isLoggedIn) {
      if (redirectTo && redirectTo !== "/") {
        navigate(redirectTo);
      } else if (user?.type === "admin") {
        navigate("/admin/");
      } else if (user?.type === "user") {
        navigate("/user/venues");
      } else {
        navigate(redirectTo);
      }
    }
  }, [isLoggedIn, user, navigate]);

  return <Component />;
};

export default GuestRouter;
